import React, {useState, useEffect, useRef, useContext} from 'react';
import {MapContext} from '_context/MapContext';
import {ollehModule} from '../../common/mapAPIExport'

const innerSize = {w:276, h:164}

const MiniMap = (props) => {
    const displayBound = {width:innerSize.w/4, height:innerSize.h/4, dx:innerSize.w/4+innerSize.w/8+4, dy:innerSize.h/4+innerSize.h/8}
    const myMap = useRef(null);

    const [opacity, setOpacity] = useState(0)
    const mapDomRef = useRef(null);
    const [rate, setRate] = useState({width:100, height:100})
    const [scale, setScale] = useState({x:1, y:1})
    const [translate, setTranslate] = useState({x:0, y:0})
    const [boxShadowOpcity, setBoxShadowOpcity] = useState(0.4)
    const [className, setClassName] = useState('wrapMiniMap')
    const elementRef = useRef(null)
    const {ktMapIns} = useContext(MapContext);
    const areaRef = useRef(null)
    const btnRef = useRef(null)

    useEffect(() => {
        if(ktMapIns){
            ktMapIns.onEvent('resize', function (event, payload) {
                rateCal(payload.width, payload.height)
            });
            ktMapIns.onEvent('idle', function (event, payload) {
                displayBund()
                // setTimeout(()=>{displayBund()}, 3000)
            });
            rateCal()

            setTimeout(()=>{
                let map = new ollehModule.maps.Map(mapDomRef.current, {
                    zoomControl: false,
                    panControl: false,
                    scaleControl: false,
                    copyrightControl: false,
                    mapTypeControl: false,
                    measureControl: false,
                    zoom:1,
                    customTrafficInfoControl:false,
                    center: props.center
                })
                map.onEvent('rightclick', function(e) {
                    e.stopPropagation();
                    e.preventDefault();
                    return false;
                });
                myMap.current = map
                let iterval = setInterval(()=>{
                    let logo = mapDomRef.current.getElementsByClassName('ollehmap-logo-control')
                    if(logo.length===1){
                        clearInterval(iterval);
                        logo[0].remove()
                    }
                },100);
                displayBund()
                setOpacity(1)
                mapDomRef.current.addEventListener('mousemove', (e)=>{e.stopPropagation()}, {capture: true});
            },1000);
        }
    }, [ktMapIns]);

    const rateCal = (mapWidth, maphHeight)=>{
        let w = mapWidth
        let h = maphHeight
        if(!w){
            let size = ktMapIns.getViewportSize()
            w = size.width
            h = size.height
        }
        setRate({width:w/innerSize.w*100, height:h/innerSize.h*100})
        setScale({x:innerSize.w/w, y:innerSize.h/h})
        setTranslate({x:(100-w/innerSize.w*100)/2, y:(100-h/innerSize.h*100)/2})
    }

    const displayBund = ()=>{
        try{
            myMap.current.setZoom(ktMapIns.getZoom()-2)
            myMap.current.setCenter(ktMapIns.getCenter());
            
        }catch(e){}
    }

    let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
    let mapAreaWidth = null;
    let mapAreaHeight = null;
    const dragMouseDown = (e)=>{
        if(!mapAreaWidth){
            mapAreaWidth = mapDomRef.current.parentNode.offsetWidth
        }
        if(!mapAreaHeight){
            mapAreaHeight = mapDomRef.current.parentNode.offsetHeight
        }
        setBoxShadowOpcity(0)
        pos1 = 0; pos2 = 0; pos3 = 0; pos4 = 0;
        e = e || window.event;
        e.preventDefault();
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.onmouseup = closeDragElement;
        document.onmousemove = elementDrag;
    }

    const elementDrag = (e)=>{
        e = e || window.event;
        e.preventDefault();
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
        let offsetLeft = e.target.offsetLeft
        let offsetTop = e.target.offsetTop
        if((offsetLeft - pos1)<0 || (offsetTop - pos2)<0 ||
           (offsetLeft - pos1) > (mapAreaWidth-displayBound.width) || 
           (offsetTop - pos2) > (mapAreaHeight-displayBound.height)){
            e.stopPropagation()
            closeDragElement(e)
            return
        }else{
            e.target.style.top = (offsetTop - pos2) + "px";
            e.target.style.left = (offsetLeft - pos1) + "px";
        }
        areaRef.current.style.top = null
        areaRef.current.style.left = null
        areaRef.current.style.right = '100px'
        areaRef.current.style.bottom = '13px'
        btnRef.current.style.top = null
        btnRef.current.style.left = null
    }

    const closeDragElement = (e)=>{
        setBoxShadowOpcity(0.4)
        document.onmouseup = null;
        document.onmousemove = null;
        let mgr = myMap.current.getOverlayLayer().layerMgr
        var x = (parseInt(e.target.style.left)+displayBound.width/2) * (rate.width/100)
        var y = (parseInt(e.target.style.top)+displayBound.height/2) * (rate.height/100)
        x = isNaN(x) ? 0 : x
        y = isNaN(y) ? 0 : y
        let utmk = mgr.getCoordFromViewportPx(new ollehModule.maps.Point(x, y))
        e.target.style.left = displayBound.dx+'px'
        e.target.style.top = displayBound.dy+'px'
        if(!isNaN(utmk.x) && !isNaN(utmk.x)){
            ktMapIns.setCenter(utmk)
        }
        areaRef.current.style.top = null
        areaRef.current.style.left = null
        areaRef.current.style.right = '100px'
        areaRef.current.style.bottom = '13px'
        btnRef.current.style.top = null
        btnRef.current.style.left = null
    }

    return (
        <div className={className} ref={areaRef}>
            <div className="inner" style={{display:className==='wrapMiniMap'?'block':'none'}}>
                <div ref={mapDomRef} id='miniMapArea' style={{width:rate.width+'%',height:rate.height+'%', opacity:opacity, 
                    transform:'scaleX('+scale.x+') scaleY('+scale.y+') translate('+(translate.x)+'%, '+(translate.y)+'%)'}}>    
                </div>
                <div ref={elementRef} id='masterMapBound' onMouseDown={(e) => dragMouseDown(e)} 
                    style={{
                        opacity:1, position:'absolute',top:displayBound.dy+'px', left:displayBound.dx+'px', 
                        boxShadow: '0 0 0 1000px rgba(0, 0, 0, '+boxShadowOpcity+')', border:'dotted 2px #ff0000',
                        width:displayBound.width+'px',height:displayBound.height+'px'}}>
                </div>
            </div>
            <button ref={btnRef} className="btnsBg btnToggle" onClick={(e)=>{setClassName(className==='wrapMiniMap'?'wrapMiniMap small':'wrapMiniMap')}}>열기/닫기</button>
        </div>
    )
}

export default MiniMap